"use client";

import React, { useMemo } from "react";
import { Icon, ospThemes } from "@ospweb/sdk-ui";
import { cn, dayjs } from "utils";
import Translations from "@translate/components/Portfolio/MembershipExpiredToast/MembershipExpiredToast";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

export interface MembershipExpiredToastProps {
  /** 自定义类名 */
  className?: string;
  /** 点击 Upgrade Plan 按钮的回调 */
  onUpgradeClick?: () => void;
  /** 最后同步时间（时间戳） */
  lastSyncedTime?: number;
}

/**
 * 会员到期 Toast 组件
 * 当会员到期且当前为导入的投资组合类型时显示
 */
export const MembershipExpiredToast: React.FC<MembershipExpiredToastProps> = ({
  className,
  onUpgradeClick,
  lastSyncedTime,
}) => {
  // 格式化最后同步时间
  const formattedTime = useMemo(() => {
    if (!lastSyncedTime) {
      return "--";
    }
    return dayjs(lastSyncedTime).format("MMM DD, HH:mm");
  }, [lastSyncedTime]);

  // 构建完整文案
  const message = useMemo(() => {
    const template = I18n.t(
      "Your imported portfolio data is not up-to-date. Last Update time: {time}",
    );
    return template.replace("{time}", formattedTime);
  }, [formattedTime]);
  return (
    <div
      className={cn(
        "flex gap-4 items-center justify-center max-md:px-4 py-2 w-full",
        "bg-background_accent2_overlay10",
        className,
      )}
    >
      {/* 左侧：错误图标和文本 */}
      <div className="flex gap-2 items-center justify-center flex-row min-w-0">
        {/* 错误图标 */}
        <Icon
          name="error-circle"
          size={16}
          color={ospThemes.colors.content_accent2_primary}
        />
        {/* 提示文本 */}
        <p className="body_medium_s text-content_primary flex-1 min-w-0">
          {message}
        </p>
      </div>

      {/* 右侧：Upgrade Plan 按钮 */}
      <button
        aria-label="Membership Expired Toast"
        data-openreplay-label="Membership Expired Toast Button"
        id="btn-membership-expired-toast"
        onClick={onUpgradeClick}
        className={cn(
          "button secondary_button xs_button button_s",
          "flex-shrink-0",
        )}
      >
        {I18n.t("Upgrade Plan")}
      </button>
    </div>
  );
};
